const subCategoryTemplate = (subcat, isActive) => `
  <li class="collection-subcategories__item${isActive ? ' active' : ''}" tabindex="-1" role="menuitem" aria-label="Navigate to: ${subcat.title}">
    <a href="${subcat.url}" class="collection-subcategories__cta" tabindex="0">
      <div class="collection-subcategories__circle">
        <img
          src="${subcat.image}"
          srcset="
            ${subcat.image.replace(/(\.[a-z]+)$/, '_80x80$1')} 80w,
            ${subcat.image.replace(/(\.[a-z]+)$/, '_160x160$1')} 160w,
            ${subcat.image.replace(/(\.[a-z]+)$/, '_320x320$1')} 320w
          "
          sizes="(max-width: 480px) 80px, (max-width: 768px) 160px, 160px"
          alt="Category menu item for ${subcat.title}"
          width="160"
          height="160"
          loading="eager"
          style="max-width:100%;height:auto"
        />
      </div>
      <div class="collection-subcategories__title">${subcat.title}</div>
    </a>
  </li>
`;

export default () => {
  const subcat_container = document.querySelector('[data-collection-subcategories]');
  if (!subcat_container) return false;

  const sub_categories_el = document.querySelector('[data-collection-sub-categories-json]');
  if (!sub_categories_el || sub_categories_el.textContent.trim() === '') {
    subcat_container.remove();
    return false;
  }

  const sub_categories_json = JSON.parse(sub_categories_el.textContent);
  if (!Array.isArray(sub_categories_json) || sub_categories_json.length === 0) return false;

  const currentHandle = window.theme?.collections?.current;
  const sub_categories_html = sub_categories_json.map(subcat =>
    subCategoryTemplate(subcat, currentHandle === subcat.handle)
  ).join('') +
    `<li class="collection-subcategories__item collection-subcategories__item--last" tabindex="-1" role="menuitem" aria-label="Last">&nbsp;</li>`;

  const ul = subcat_container.querySelector('ul');
  if (ul) ul.innerHTML = sub_categories_html;

  subcat_container.classList.remove('loading');
  subcat_container.classList.add('loaded');
};
